let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7uS3Z")).then(() => parcelRequire('5JjoD'));